/**
 * @generated SignedSource<<d7dcc0cbbd136cb9b9f6f4f268ea9b1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CartChannel = "businessshop" | "personalshop" | "personalss" | "sparkdigitalshop";
export type FrequencyPeriod = "Day" | "Hour" | "Month" | "Week" | "Year";
export type SubscriptionComparisonCTAType = "CANCEL" | "INFORM" | "KEEP";
export type SubscriptionChangePlanComparisonFieldQuery$variables = {
  lineNumber: string;
  addOffer: string;
  channel: CartChannel;
};
export type SubscriptionChangePlanComparisonFieldQuery$data = {
  readonly changePlanSubscriptionsComparison: {
    readonly comparisons: ReadonlyArray<{
      readonly recommendationId: string;
      readonly available: {
        readonly offerId: string;
        readonly offerName: string;
        readonly brand: string | null;
        readonly isIncluded: boolean | null;
        readonly iconUrl: string | null;
        readonly price: {
          readonly basePrice: number | null;
          readonly description: string | null;
          readonly frequencyPeriod: FrequencyPeriod | null;
        } | null;
      } | null;
      readonly unavailable: {
        readonly offerId: string;
        readonly offerName: string;
        readonly brand: string | null;
        readonly isIncluded: boolean | null;
        readonly iconUrl: string | null;
        readonly price: {
          readonly description: string | null;
          readonly basePrice: number | null;
          readonly frequencyPeriod: FrequencyPeriod | null;
        } | null;
      } | null;
      readonly ctas: ReadonlyArray<{
        readonly type: SubscriptionComparisonCTAType;
      }> | null;
    }>;
  };
};
export type SubscriptionChangePlanComparisonFieldQuery = {
  variables: SubscriptionChangePlanComparisonFieldQuery$variables;
  response: SubscriptionChangePlanComparisonFieldQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "addOffer"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "channel"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lineNumber"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "offerId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "offerName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "brand",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isIncluded",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iconUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "basePrice",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "frequencyPeriod",
  "storageKey": null
},
v11 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "addOffer",
        "variableName": "addOffer"
      },
      {
        "kind": "Variable",
        "name": "channel",
        "variableName": "channel"
      },
      {
        "kind": "Variable",
        "name": "lineNumber",
        "variableName": "lineNumber"
      }
    ],
    "concreteType": "SubscriptionsComparisonWithOfferDetailsResponse",
    "kind": "LinkedField",
    "name": "changePlanSubscriptionsComparison",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SubscriptionsComparisons",
        "kind": "LinkedField",
        "name": "comparisons",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recommendationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SubscriptionComparisonOffer",
            "kind": "LinkedField",
            "name": "available",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SubscriptionsComparisonOfferPrice",
                "kind": "LinkedField",
                "name": "price",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SubscriptionComparisonOffer",
            "kind": "LinkedField",
            "name": "unavailable",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SubscriptionsComparisonOfferPrice",
                "kind": "LinkedField",
                "name": "price",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v8/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SubscriptionsComparisonCtas",
            "kind": "LinkedField",
            "name": "ctas",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscriptionChangePlanComparisonFieldQuery",
    "selections": (v11/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "SubscriptionChangePlanComparisonFieldQuery",
    "selections": (v11/*: any*/)
  },
  "params": {
    "cacheID": "8ac4a062e3569dfbe8be0d7a027e4e99",
    "id": null,
    "metadata": {},
    "name": "SubscriptionChangePlanComparisonFieldQuery",
    "operationKind": "query",
    "text": "query SubscriptionChangePlanComparisonFieldQuery(\n  $lineNumber: String!\n  $addOffer: String!\n  $channel: CartChannel!\n) {\n  changePlanSubscriptionsComparison(lineNumber: $lineNumber, addOffer: $addOffer, channel: $channel) {\n    comparisons {\n      recommendationId\n      available {\n        offerId\n        offerName\n        brand\n        isIncluded\n        iconUrl\n        price {\n          basePrice\n          description\n          frequencyPeriod\n        }\n      }\n      unavailable {\n        offerId\n        offerName\n        brand\n        isIncluded\n        iconUrl\n        price {\n          description\n          basePrice\n          frequencyPeriod\n        }\n      }\n      ctas {\n        type\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "da1a6915f431e939a2447bf086ad3ca8";

export default node;
